import React, { Component, Fragment } from "react";
import "./sizing.css";
import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";
import { getCoalTowerCapacities, getCoalTowerModelsById, getModelByParameters } from "../../constants/sizing-constant";
import { Link } from "react-router-dom";

export default class CoalTowerSizing extends Component {

    state = {
        coalTowerCapacities: [],
        selectedCoalTowerCapacity: "0",
        suggestedModel: "",
        suggestedModelId: "",
        totalHigth: "",
        volum:""
    };

    componentDidMount() {
        this.setState({ coalTowerCapacities: [...getCoalTowerCapacities()] });
    };

    componentWillReceiveProps(Values) {
        this.setState({ products: Values.products });
    };

    handleCoalTowerCapacitySelect = capacity => {
        if (capacity) {
            this.setState({ selectedCoalTowerCapacity: capacity.value }, () => {
                this.findModel();
            });
        }
    };

    findModel() {
        var result = getModelByParameters("6", this.state.selectedCoalTowerCapacity)[0];
        this.setState({ suggestedModel: result.label });
        this.setState({ suggestedModelId: result.Id });
        this.setState({ totalHigth: result.totalHigth });
        this.setState({ volum: result.volum });
    }

    render() {
        return (
            <Fragment>
                <DropDownWhiteStyle
                    items={this.state.coalTowerCapacities}
                    placeholder="ظرفیت اسمی"
                    onItemSelect={this.handleCoalTowerCapacitySelect}
                />
                {this.state.suggestedModel !== "" &&
                    <Fragment>
                        <h1 className="text-title-body">مدل پیشنهادی برای شما :</h1>
                        <div className="modelheadbox">
                            <h1 >{this.state.suggestedModel}</h1>
                            <hr className="divider" />
                        </div>
                        <h3 className="text-title-description">حد بالای فشار : {this.state.totalHigth} (mm)</h3>
                        <h3 className="text-title-description">حجم : {this.state.volum} (lite)</h3>
                        <h3 className="text-title-description">Minimum Working Pressure : 4 barg 58 psig</h3>
                        <h3 className="text-title-description">Maximum Working Pressure : 16 barg 232 psig</h3>
                        <h3 className="text-title-description">Minimum Inlet Temperature : 1.5 c 35 F</h3>
                        <h3 className="text-title-description">Maximum Inlet Temperature : 50 c 122 F</h3>
                        <h3 className="text-title-description">Minimum Ambient Temperature : 5 c 41 f</h3>
                        <div className="row hrow mt-4">
                            <Link className="btn btn-dark" to={`/partRequst/${this.state.suggestedModelId}`} >درخواست خرید این مدل</Link>
                        </div>
                    </Fragment>
                }
            </Fragment>
        );
    }
}
